export const YY_MM: string = 'YYYY-MM';
export const YYYY_MM_DD: string = 'YYYY-MM-DD';
export const YYYY_MM_DD_HH_MM_SS: string = 'YYYY-MM-DD HH:mm:ss';
export const DD_MM_YYYY = 'DD/MM/YYYY';
export const DD_MM_YYYY_HH_MM_SS = 'DD/MM/YYYY HH:mm:ss';
export const YYYY = 'YYYY';
